import { assert_number_gte } from '@shared/asserts/utils_asserts';
import { DTO__grid2d_virtual } from '@shared/dto/grid2d_virtual/DTO__grid2d_virtual';
import { Virtualizer } from '@tanstack/react-virtual';
import { MutableRefObject, useState } from 'react';
import { use_effect } from '../../../../hooks/_base/use_effect';
import { HOOK__run_on_next_frame } from '../../../../hooks/HOOK__run_on_next_frame';

export function HOOK_GRID2D__first_scroll_to(
  grid2d_virtual: DTO__grid2d_virtual,
  slug_offset: number,
  virtualizer: Virtualizer<HTMLDivElement, Element>,
  update_possible_on_screen_cells_indices: () => void,
  is_enabled: boolean,
  max_side: number,
  ref_is_slug_offset_locked_by_scroll: MutableRefObject<boolean>,
) {
  const [is_first_scroll_done, set_is_first_scroll_done] = useState(false);

  const run_on_next_frame_1 = HOOK__run_on_next_frame();
  const run_on_next_frame_2 = HOOK__run_on_next_frame();

  /*
   * EFFECTS
   */

  use_effect(() => {
    if (grid2d_virtual.grid2d.is_stub()) return;
    if (!is_enabled) return;
    if (is_first_scroll_done) return; //when we load grid first time we need scroll to slug_offset and then we set is_first_scroll_done=false so that there is no endless loop when setting the offset
    if (!Number.isSafeInteger(slug_offset)) return; // we can get NaN if slug_offset in url will be wrong
    if (grid2d_virtual.total_columns === 0) return; // grid2d_virtual and virtualizer properties are not calculated yet based on viewport size

    if (slug_offset === 0) return set_is_first_scroll_done(true);

    assert_number_gte(slug_offset, 0);

    const { cells__amount__grid2d_total: grid2d_total_cells_amount } = grid2d_virtual;

    if (grid2d_total_cells_amount <= slug_offset) return;

    //we need wait one frame for ready virtualizer

    run_on_next_frame_1(() => {
      virtualizer.scrollToIndex(slug_offset, { align: 'start' });

      update_possible_on_screen_cells_indices();

      set_is_first_scroll_done(true);
    });
  }, [
    virtualizer,
    slug_offset,
    update_possible_on_screen_cells_indices,
    grid2d_virtual,
    is_first_scroll_done,
    grid2d_virtual.cells__amount__visible,
    is_enabled,
  ]);

  use_effect(() => {
    ref_is_slug_offset_locked_by_scroll.current = true;

    run_on_next_frame_2(() => {
      virtualizer.scrollToIndex(slug_offset, { align: 'start' });

      update_possible_on_screen_cells_indices();

      ref_is_slug_offset_locked_by_scroll.current = false;
    });
  }, [max_side, virtualizer]);

  return { is_first_scroll_done, set_is_first_scroll_done };
}
